<template>
  <!-- Fila única para la información de las ventas -->
  <v-row class="deltia-card ml-2 mr-2 mb-4" justify="center" align="center">
    <!-- Fila para la información -->
    <v-col cols="12" class="pl-5 pr-5">
      <!------------------------>
      <!-- Pantallas pequeñas -->
      <!------------------------>
      <v-row no-gutters class="mt-2 mb-2 hidden-md-and-up">
        <!-- Total de la venta -->
        <v-col cols="6" class="text-left">
          <p class="font-weight-medium pa-0 mb-0 text--disabled">
            Total
          </p>
          <p class="text-h6 mb-0 pa-0 primary--text font-weight-medium">
            ${{ saleData.total }}
          </p>
        </v-col>
        <!-- Mesa -->
        <v-col v-if="isRestaurant" cols="6" class="text-left">
          <div>
            <p class="font-weight-medium pa-0 mb-0 text--disabled">
              Mesa
            </p>
            <p
              v-if="saleData.table_people_count"
              class="text-h6 mb-0 pa-0 content--text font-weight-medium"
            >
              {{ table.name }}
              <span class="font-weight-normal content--text">
                ({{ saleData.table_people_count }}
                {{
                  saleData.table_people_count === 1 ? "persona" : "personas"
                }})
              </span>
            </p>
            <p
              v-else
              class="text-h6 mb-0 pa-0 content--text font-weight-medium"
            >
              {{ table.name }}
            </p>
          </div>
        </v-col>
        <v-col v-else cols="6" />
        <!-- Estado de la venta -->
        <v-col cols="12" class="text-right mt-2 mb-2 flex">
          <v-menu
            transition="slide-y-transition"
            bottom
            v-model="statusMenuSmall"
          >
            <template v-slot:activator="{ on: statusMenuSmall }">
              <v-btn
                :loading="isStatusLoading"
                v-on="statusMenuSmall"
                :color="getSaleStatusData(saleData.status).color"
                class="white--text"
                depressed
                rounded
              >
                {{ getSaleStatusData(saleData.status).name }}
                <!-- <v-icon right>mdi-menu-down</v-icon> -->
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in getStasuses()"
                :key="index"
                @click="updateStatus(item)"
              >
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <!-- Otras opciones -->
          <v-menu bottom v-model="optionsMenuSmall">
            <template v-slot:activator="{ on: optionsMenuSmall }">
              <v-btn
                class="font-weight-bold"
                color="secondary"
                v-on="optionsMenuSmall"
                icon
              >
                <v-icon>
                  mdi-dots-horizontal-circle-outline
                </v-icon>
              </v-btn>
            </template>
            <!-- Menú de opciones -->
            <v-list>
              <!-- Facturar venta -->
              <BillSale
                v-if="billingEnabled && !saleData.billing_info"
                :saleData="saleData"
                :products="products"
              />
              <DownloadBill
                v-else-if="saleData.billing_info"
                :saleData="saleData"
              />
              <!-- Imprimir venta -->
              <PrintSale
                :customer="customer"
                :saleData="saleData"
                :products="products"
              />
              <!-- Editar venta -->
              <EditSale :saleData="saleData" />
              <!-- Eliminar venta -->
              <DeleteSale
                v-if="checkIfTheUserCanDeleteTheSale"
                :movementId="saleData._id"
                @sale-deleted="onSaleDeleted"
                @sale-error="onSaleError"
              />
            </v-list>
          </v-menu>
        </v-col>
        <!-- Línea divisora -->
        <v-col cols="12" class="mb-0 pt-1 pb-0">
          <v-divider></v-divider>
        </v-col>
      </v-row>
      <v-row class="hidden-md-and-up">
        <!-- Fila para los encabezados de la venta -->
        <v-col class="pb-0" cols="12">
          <v-row no-gutters>
            <v-col class="pb-0" cols="5">
              <p class="font-weight-medium pa-0 mb-0 text--disabled">
                Producto
              </p>
            </v-col>
            <v-col class="pb-0 text-center" cols="4">
              <p class="font-weight-medium pa-0 mb-0 text--disabled">
                Descuento
              </p>
            </v-col>
            <v-col class="pb-0 text-center" cols="3">
              <p class="font-weight-medium pa-0 mb-0 text--disabled">
                Subtotal
              </p>
            </v-col>
          </v-row>
        </v-col>
        <!-- Columna para la información de cada producto -->
        <v-col v-for="product in products" :key="product._id" cols="12">
          <v-row no-gutters>
            <!-- Columna para el nombre-->
            <v-col class="pt-0 pb-0" cols="5">
              <p class="content--text font-weight-medium">
                {{ product.name }}(${{ product.pricePerUnit }}x{{
                  product.quantity
                }})
              </p>
            </v-col>
            <!-- Columna para el descuento -->
            <v-col class="pt-0 pb-0" cols="4">
              <p class="content--text font-weight-medium text-center">
                ${{ product.discount }}
              </p>
            </v-col>
            <!-- Columna para el subtotal -->
            <v-col class="pt-0 pb-0" cols="3">
              <p class="content--text font-weight-medium text-center">
                ${{ product.amount }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <!-- Columna que despliega las ventas -->
        <v-col class="pa-0" cols="12" no-gutters v-if="collapse">
          <v-col>
            <!-- Línea divisora -->
            <v-col cols="12" md="12" class="mb-0 pt-0 pb-0 pr-0 pl-0">
              <v-divider></v-divider>
            </v-col>
            <!-- Monto adicional -->
            <v-col cols="12" class="pr-0 pl-0">
              <p class="font-weight-medium pa-0 mb-0 text--disabled">
                Monto adicional
              </p>
              <p class="content--text font-weight-medium mb-1">
                ${{ saleData.additional_amount }}
              </p>
            </v-col>
            <!-- Método de pago -->
            <v-col cols="12" class="pr-0 pl-0">
              <p class="font-weight-medium mb-0 text--disabled">
                Método de pago
              </p>
              <p class="content--text font-weight-medium mb-1">
                {{ findPaymentMethod(saleData.payment_method) }}
              </p>
            </v-col>
            <!-- Línea divisora -->
            <v-col cols="12" md="12" class="mb-0 pt-0 pb-0 pr-0 pl-0">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" md="12" class="pb-0 mb-0 pl-0">
              <v-row>
                <!-- Columna para el creador de la venta -->
                <v-col class="pt-0 pl-0" md="5">
                  <v-col class="pt-0 pb-0" cols="12">
                    <p class="font-weight-medium pa-0 mb-0 text--disabled">
                      Usuario
                    </p>
                  </v-col>
                  <!-- Columna para la cantidad de productos vendidos -->
                  <v-col cols="12" class="pt-0 pb-0">
                    <p class="content--text font-weight-medium mb-0">
                      {{ user.name }}
                    </p>
                  </v-col>
                </v-col>
                <!-- Columna para la fecha -->
                <v-col class="pt-0" md="4">
                  <v-col class="pt-0 pb-0" cols="12">
                    <p class="font-weight-medium pa-0 mb-0 text--disabled">
                      Fecha
                    </p>
                  </v-col>
                  <!-- Columna para la fecha -->
                  <v-col cols="12" class="pt-0 pb-0">
                    <p class="content--text font-weight-medium mb-0">
                      {{ formatDate(saleData.created_at) }}
                    </p>
                  </v-col>
                </v-col>
                <!-- Columna para la sucursal -->
                <v-col class=" pt-0 pl-0" md="3">
                  <v-col class="pt-0 pb-0" cols="12">
                    <p class="font-weight-medium pa-0 mb-0 text--disabled">
                      Sucursal
                    </p>
                  </v-col>
                  <!-- Columna para la cantidad de productos vendidos -->
                  <v-col cols="12" class="pt-0 pb-0">
                    <p class="content--text font-weight-medium mb-0">
                      {{ branch ? branch.name : "Sin sucursal" }}
                    </p>
                  </v-col>
                </v-col>
                <v-col cols="12" md="12" class="mb-0 pt-0 pb-0 pr-0">
                  <v-divider></v-divider>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="12" class="pb-0 mb-0 pl-0 pr-0">
              <v-row>
                <!-- Texto de URL compartible -->
                <v-col cols="12" class="pt-0 pb-0">
                  <p class="font-weight-medium pa-0 mb-0 text--disabled">
                    Url compartible
                  </p>
                </v-col>
                <!-- Columna para la cantidad de productos vendidos -->
                <v-col cols="6" class="pt-0 pb-0">
                  <v-switch
                    :label="
                      `${saleData.is_shareable ? 'Activada' : 'Desactivada'}`
                    "
                    :loading="isShareableStatusLoading"
                    @change="updateShareableStatus"
                    v-model="saleData.is_shareable"
                    color="secondary"
                    class="pt-0"
                    inset
                    flat
                  />
                </v-col>
                <!-- Columna para el botón de copiar url -->
                <v-col cols="6" class="text-right">
                  <v-btn
                    v-if="saleData.is_shareable"
                    @click="copyShareableUrl"
                    color="secondary"
                    class="white--text"
                    depressed
                    rounded
                  >
                    COPIAR URL
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-col>
        </v-col>
      </v-row>
      <!-------------------------------------->
      <!-- Pantallas medianas y más grandes -->
      <!-------------------------------------->
      <template>
        <v-row class="mt-4 hidden-sm-and-down">
          <!-- Total de la venta -->
          <v-col cols="12" md="3" class="pb-0 pt-0 pl-0">
            <v-col class="pt-0 pb-0">
              <p class="font-weight-medium mb-0 text--disabled">
                Total
              </p>
            </v-col>
            <v-col class="pt-0 pb-0 pt-0 mb-0 mt-0">
              <p class="text-h6 mb-0 primary--text font-weight-bold">
                ${{ saleData.total }}
              </p>
            </v-col>
          </v-col>
          <v-col v-if="isRestaurant" cols="12" md="2" class="pb-0 pt-0 pl-0">
            <p class="font-weight-medium pa-0 mb-0 text--disabled">
              Mesa
            </p>
            <p
              v-if="saleData.table_people_count"
              class="text-h6 mb-0 pa-0 content--text font-weight-medium"
            >
              {{ table.name }}
              <span class="font-weight-normal content--text">
                ({{ saleData.table_people_count }}
                {{
                  saleData.table_people_count === 1 ? "persona" : "personas"
                }})
              </span>
            </p>
            <p
              v-else
              class="text-h6 mb-0 pa-0 content--text font-weight-medium"
            >
              {{ table.name }}
            </p>
          </v-col>
          <v-col v-else cols="12" md="2" />
          <!-- Estado de la venta -->
          <v-col cols="12" md="7" class="pb-0 pl-0 pt-0 text-right">
            <!-- Menu -->
            <v-menu
              transition="slide-y-transition"
              bottom
              rounded
              v-model="statusMenu"
            >
              <template v-slot:activator="{ on: statusMenu }">
                <v-btn
                  :loading="isStatusLoading"
                  :color="getSaleStatusData(saleData.status).color"
                  class="white--text"
                  v-on="statusMenu"
                  depressed
                  rounded
                >
                  {{ getSaleStatusData(saleData.status).name }}
                  <!-- <v-icon right>mdi-menu-down</v-icon> -->
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in getStasuses()"
                  :key="index"
                  @click="updateStatus(item)"
                >
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
              </v-list>
              <!-- <v-boton right>
                mdi-menu-down
              </v-boton> -->
            </v-menu>
            <!-- Otras opciones -->
            <v-menu bottom v-model="optionsMenu">
              <template v-slot:activator="{ on: optionsMenu }">
                <v-btn
                  class="font-weight-bold"
                  color="secondary"
                  v-on="optionsMenu"
                  icon
                >
                  <v-icon>
                    mdi-dots-horizontal-circle-outline
                  </v-icon>
                </v-btn>
              </template>
              <!-- Menú de opciones -->
              <v-list>
                <!-- Facturar venta -->
                <BillSale
                  v-if="billingEnabled && !saleData.billing_info"
                  :saleData="saleData"
                  :products="products"
                />
                <DownloadBill
                  v-else-if="saleData.billing_info"
                  :saleData="saleData"
                />
                <!-- Imprimir venta -->
                <PrintSale
                  :customer="customer"
                  :saleData="saleData"
                  :products="products"
                />
                <!-- Editar venta -->
                <EditSale :saleData="saleData" />
                <!-- Eliminar venta -->
                <DeleteSale
                  v-if="checkIfTheUserCanDeleteTheSale"
                  :movementId="saleData._id"
                  @sale-deleted="onSaleDeleted"
                  @sale-error="onSaleError"
                />
              </v-list>
            </v-menu>
          </v-col>
          <!-- Línea divisora -->
          <v-col cols="12" md="12" class="mb-0 pt-0 pb-0">
            <v-divider></v-divider>
          </v-col>
        </v-row>
        <v-row class="hidden-sm-and-down">
          <!-- Fila para los encabezados de la venta -->
          <v-col cols="12" md="12" class="pt-0 pr-10">
            <v-row>
              <v-col class=" pb-0" cols="12" md="4">
                <p class="font-weight-medium mb-0 text--disabled">Producto</p>
              </v-col>
              <v-col class="text-center pb-0" md="2">
                <p class="font-weight-medium mb-0 text--disabled">Precio u.</p>
              </v-col>
              <v-col class="text-center pb-0" md="2">
                <p class="font-weight-medium mb-0 text--disabled">Cantidad</p>
              </v-col>
              <v-col class="text-center pb-0" md="2">
                <p class="font-weight-medium mb-0 text--disabled">Descuento</p>
              </v-col>
              <v-col class="hidden-sm-and-down text-center pb-0" md="2">
                <p class="font-weight-medium mb-0 text--disabled">Subtotal</p>
              </v-col>
            </v-row>
          </v-col>
          <!-- Columna para la información de cada producto -->
          <v-col
            v-for="product in products"
            :key="product._id"
            cols="12"
            md="12"
            class="pt-0 pb-0 pr-10"
          >
            <v-row justify="center">
              <!-- Columna para el nombre-->
              <v-col class="pt-0 pb-0" md="4">
                <p class="content--text font-weight-medium">
                  {{ product.name }}
                </p>
              </v-col>
              <!-- Columna  para el precio unitario-->
              <v-col class="pt-0 pb-0" md="2">
                <p class="content--text font-weight-medium text-center">
                  ${{ product.pricePerUnit }}
                </p>
              </v-col>
              <!-- Columna para la cantidad -->
              <v-col class="pt-0 pb-0" md="2">
                <p class="content--text font-weight-medium text-center">
                  {{ product.quantity }}
                </p>
              </v-col>
              <!-- Descuento -->
              <v-col class="pt-0 pb-0" md="2">
                <p class="content--text font-weight-medium text-center">
                  <!-- eslint-disable-next-line prettier/prettier -->
                  ${{ product.discount ? product.discount : 0 }}
                </p>
              </v-col>
              <!-- Columna para el subtotal de una producto -->
              <v-col class="pt-0 pb-0 text-center" md="2">
                <p class="content--text font-weight-medium">
                  ${{ product.amount }}
                </p>
              </v-col>
            </v-row>
          </v-col>
          <!-- Línea divisora -->
          <v-row v-if="collapse">
            <v-col>
              <v-col cols="12" class="mb-0 pt-0 pb-0">
                <v-divider></v-divider>
              </v-col>
              <!-- Datos del cliente -->
              <v-col cols="12" class="pb-0 mb-0 pl-0">
                <v-row>
                  <!-- Monto adicional -->
                  <v-col class="pt-0" md="5">
                    <v-col class="pt-0 pb-0" cols="12">
                      <p class="font-weight-medium mb-0 text--disabled">
                        Monto adicional
                      </p>
                      <p class="content--text font-weight-medium mb-1">
                        ${{ saleData.additional_amount }}
                      </p>
                    </v-col>
                  </v-col>
                  <!-- Método de pago -->
                  <v-col class="pt-0" md="4">
                    <v-col class="pt-0 pb-0" cols="12">
                      <p class="font-weight-medium mb-0 text--disabled">
                        Método de pago
                      </p>
                      <p class="content--text font-weight-medium mb-1">
                        {{ findPaymentMethod(saleData.payment_method) }}
                      </p>
                    </v-col>
                  </v-col>
                  <!-- Cliente -->
                  <v-col class="pt-0 pl-0" md="3">
                    <v-col class="pt-0 pb-0" cols="12">
                      <p class="font-weight-medium mb-0 text--disabled">
                        Cliente
                      </p>
                      <p class="content--text font-weight-medium mb-1">
                        {{
                          customer.full_name
                            ? customer.full_name
                            : "Sin cliente"
                        }}
                      </p>
                    </v-col>
                  </v-col>
                </v-row>
              </v-col>
              <!-- Línea divisora -->
              <v-col cols="12" class="mb-0 pt-0 pb-0">
                <v-divider></v-divider>
              </v-col>
              <!-- Información extra de la venta -->
              <v-col cols="12" class="pb-0 mb-0 pl-0">
                <v-row>
                  <!-- Columna para el creador de la venta -->
                  <v-col class="pt-0" md="5">
                    <v-col class="pt-0 pb-0" cols="12">
                      <p class="font-weight-medium mb-0 text--disabled">
                        Usuario
                      </p>
                    </v-col>
                    <!-- Columna para la cantidad de productos vendidos -->
                    <v-col cols="12" class="pt-0 pb-0">
                      <p class="content--text font-weight-medium mb-0">
                        {{ user.name }}
                      </p>
                    </v-col>
                  </v-col>
                  <!-- Columna para la fecha -->
                  <v-col class="pt-0" md="4">
                    <v-col class="pt-0 pb-0" cols="12">
                      <p class="font-weight-medium mb-0 text--disabled">
                        Fecha
                      </p>
                    </v-col>
                    <!-- Columna para la fecha -->
                    <v-col cols="12" class="pt-0 pb-0">
                      <p class="content--text font-weight-medium mb-0">
                        {{ formatDate(saleData.created_at) }}
                      </p>
                    </v-col>
                  </v-col>
                  <!-- Columna para la sucursal -->
                  <v-col class="pt-0 pl-0" md="3">
                    <v-col class="pt-0 pb-0" cols="12">
                      <p class="font-weight-medium mb-0 text--disabled">
                        Sucursal
                      </p>
                    </v-col>
                    <!-- Columna para la cantidad de productos vendidos -->
                    <v-col cols="12" class="pt-0 pb-0">
                      <p class="content--text font-weight-medium mb-0">
                        {{ branch ? branch.name : "Sin sucursal" }}
                      </p>
                    </v-col>
                  </v-col>
                  <v-col cols="12" md="12" class="mb-0 pt-0 pb-0 pl-6">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="12" class="pb-0 mb-0">
                <v-row align="center" justiy="end">
                  <v-col cols="12" class="pt-0 pb-0">
                    <p class="font-weight-medium mb-0 text--disabled">
                      Url compartible
                    </p>
                  </v-col>
                  <!-- Columna para la cantidad de productos vendidos -->
                  <v-col cols="2" class="pt-0 pb-0">
                    <v-switch
                      :label="
                        `${saleData.is_shareable ? 'Activada' : 'Desactivada'}`
                      "
                      :loading="isShareableStatusLoading"
                      @change="updateShareableStatus"
                      v-model="saleData.is_shareable"
                      class="pt-0"
                      color="secondary"
                      inset
                      flat
                    />
                  </v-col>
                  <!-- Columna para el botón de copiar url -->
                  <v-col cols="8">
                    <v-btn
                      v-if="saleData.is_shareable"
                      @click="copyShareableUrl"
                      color="secondary"
                      class="white--text"
                      depressed
                      rounded
                    >
                      COPIAR URL
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>
          </v-row>
        </v-row>
      </template>
    </v-col>
    <v-col cols="12" align="center">
      <v-btn depressed rounded @click="collapseItem">
        <!-- Text -->
        <span v-if="collapse">Mostrar menos</span>
        <span v-else>Mostrar más</span>
        <!-- Icon -->
        <v-icon v-if="collapse" right>mdi-chevron-double-up</v-icon>
        <v-icon v-else right>mdi-chevron-double-down</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
// importamos servicios
import BranchesServices from "@/services/BranchesServices";
import ProductsServices from "@/services/ProductsServices";
import UsersServices from "@/services/UsersServices";
import MovementsServices from "@/services/MovementsServices";
import CustomersServices from "@/services/CustomersServices";
import TablesService from "@/services/TablesServices";

// Importar componentes
import DeleteSale from "@/components/movements/modals/DeleteSale";
import PrintSale from "./modals/PrintSale.vue";
import BillSale from "./modals/BillSale.vue";
import DownloadBill from "./modals/DownloadBill.vue";
import EditSale from "./modals/EditSale.vue";

// Importar mixins
import dateFormat from "@/mixins/dateFormat";
import salesStatuses from "@/mixins/salesStatuses";
import paymentMethods from "@/mixins/paymentMethods";

// Importar getters
import { mapGetters } from "vuex";

export default {
  name: "SaleItem",
  mixins: [dateFormat, salesStatuses, paymentMethods],
  props: {
    saleData: {
      type: Object
    },
    billingEnabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      statusMenu: false,
      statusMenuSmall: false,
      optionsMenu: false,
      optionsMenuSmall: false,
      isStatusLoading: false,
      isShareableStatusLoading: false,
      collapse: false,
      products: [],
      branch: {},
      user: {},
      status: {},
      customer: {},
      table: {}
    };
  },
  components: {
    DeleteSale,
    PrintSale,
    BillSale,
    DownloadBill,
    EditSale
  },
  created: async function() {
    try {
      // Obtener nombre de la sucursal
      if (this.saleData.branch_id) {
        this.branch = await BranchesServices.getBranch(this.saleData.branch_id);
      }

      // Obtener nombre del consumidor
      if (!!this.saleData.customer_id) {
        this.customer = await CustomersServices.getCustomerById(
          this.saleData.customer_id
        );
      }

      // Obtener mesa
      if (!!this.saleData.table_id) {
        this.table = await TablesService.getTableById(this.saleData.table_id);
      }

      // Obtener datos de cada producto
      if (this.saleData.products.length > 0) {
        // Iteramos entre los productos de una venta multiple
        this.saleData.products.map(async product => {
          let currentProduct = await ProductsServices.getProductById(
            product.product_id
          );
          currentProduct.quantity = product.quantity;
          currentProduct.amount = product.amount;
          currentProduct.discount = product.discount ? product.discount : 0;
          currentProduct.pricePerUnit = product.price_per_unit;
          this.products.push(currentProduct);
        });
      } else {
        let currentProduct = await ProductsServices.getProductById(
          this.saleData.product_id
        );
        currentProduct.quantity = this.saleData.quantity;
        currentProduct.amount = this.saleData.amount;
        currentProduct.pricePerUnit = this.saleData.price_per_unit;
        this.products = [currentProduct];
      }
      // Obtener usuario que registró la venta
      this.user = await UsersServices.getEmployeeById(this.saleData.user_id);
    } catch (err) {
      // Emitir el error
      this.$emit("sale-error", err.message);
    }
  },
  methods: {
    collapseItem: function() {
      this.collapse = !this.collapse;
    },
    onSaleError: function(errorMessage) {
      this.$emit("sale-error", errorMessage);
    },
    onSaleDeleted: function() {
      this.$emit("sale-deleted");
    },
    updateStatus: async function(item) {
      // Mostrar spinner
      this.isStatusLoading = true;

      // Realizamos la petición
      try {
        await MovementsServices.updateSaleStatus(this.saleData._id, {
          status: item.type
        });

        // Actualizar status de la venta
        this.saleData.status = item.type;

        // Ocultar spinner
        this.isStatusLoading = false;
      } catch (err) {
        // Ocultar spinner
        this.isStatusLoading = false;

        this.onSaleError(err.message);
      }
    },
    copyShareableUrl: async function() {
      // Crear elemento
      var el = document.createElement("textarea");

      // Definir el texto que se va a copiar
      el.value = `${window.location.origin}/sales/shared?saleId=${this.saleData._id}`;

      // Dejarlo fuera de la pantalla
      el.setAttribute("readonly", "");
      el.style = { position: "absolute", left: "-9999px" };

      // Agregarlo al documento y seleccionarlo
      document.body.appendChild(el);
      el.select();

      // Copiar el texto
      document.execCommand("copy");

      // Remover el elemento
      document.body.removeChild(el);
    },
    updateShareableStatus: async function(isShareable) {
      // Mostrar spinner
      this.isShareableStatusLoading = true;

      try {
        await MovementsServices.updateShareableStatus(
          this.saleData._id,
          isShareable
        );

        // Actualizar venta
        this.saleData.is_shareable = isShareable;

        // Ocultar spinner
        this.isShareableStatusLoading = false;
      } catch (err) {
        // Ocultar spinner
        this.isShareableStatusLoading = false;

        this.onSaleError(err.message);
      }
    }
  },
  computed: {
    ...mapGetters(["getProfile", "getBusiness"]),
    checkIfTheUserCanDeleteTheSale() {
      if (this.getProfile.user_type === "owner") {
        return true;
      } else {
        return false;
      }
    },
    isRestaurant() {
      return this.getBusiness.sector === "restaurant";
    }
  }
};
</script>
